import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withKeys as _withKeys, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "ant-row"
}
const _hoisted_2 = { class: "ant-col ant-col-xs-24 ant-col-xl-24 ss-alinhar-desktop-direita-mobile-centro" }
const _hoisted_3 = { class: "ant-btn-group" }
const _hoisted_4 = { class: "ant-btn ant-btn-secondary ss-botoes-icones" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "ss-alinhar-centro" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Teclas de Atalho - Grade de Itens")
], -1)
const _hoisted_6 = { class: "ant-row" }
const _hoisted_7 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_8 = {
  key: 0,
  class: "acoes-item"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  key: 9,
  class: "ss-table-apresentacao-mobile"
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = {
  class: "acoes-item",
  style: {"margin-top":"2px"}
}
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_icone = _resolveComponent("icone")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_selecionar_produto_movimento = _resolveComponent("selecionar-produto-movimento")!
  const _component_selecionar_unidade_produto_movimento = _resolveComponent("selecionar-unidade-produto-movimento")!
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_selecionar_preco_produto_movimento = _resolveComponent("selecionar-preco-produto-movimento")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_venda_item_modal = _resolveComponent("venda-item-modal")!
  const _component_detalhes_produto_modal = _resolveComponent("detalhes-produto-modal")!
  const _component_selecionar_kit_produtos_modal = _resolveComponent("selecionar-kit-produtos-modal")!
  const _component_consulta_produtos_modal = _resolveComponent("consulta-produtos-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.props.editavel)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_a_tooltip, {
                title: "Consultar Produtos",
                placement: "left"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("button", {
                    class: "ant-btn ant-btn-secondary ss-acao-destaque-secundaria",
                    style: {"margin-top":"4px"},
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.abrirConsultaProdutos && _ctx.abrirConsultaProdutos(...args)))
                  }, "Consultar Produtos")
                ]),
                _: 1
              }),
              _createVNode(_component_a_tooltip, {
                title: "Utilizar Kit",
                placement: "left"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("button", {
                    class: "ant-btn ant-btn-secondary ss-acao-destaque-secundaria",
                    style: {"margin-top":"4px"},
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.abrirKit && _ctx.abrirKit(...args)))
                  }, "Utilizar Kit")
                ]),
                _: 1
              }),
              _createVNode(_component_a_tooltip, {
                title: "Adicionar Novo Item",
                placement: "left"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("button", {
                    class: "ant-btn ant-btn-secondary ss-acao-destaque-secundaria",
                    style: {"margin-top":"4px"},
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.adicionarItemGrade(true)))
                  }, "Inserir item")
                ]),
                _: 1
              }),
              _createVNode(_component_a_dropdown, null, {
                overlay: _withCtx(() => [
                  _createVNode(_component_a_menu, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_menu_item, null, {
                        default: _withCtx(() => [
                          _hoisted_5
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_menu_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_tag, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Shift + N")
                            ]),
                            _: 1
                          }),
                          _createTextVNode(" Adicionar novo Item ")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_menu_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_tag, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Shift + E")
                            ]),
                            _: 1
                          }),
                          _createTextVNode(" Editar detalhes do produto ")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_menu_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_tag, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Shift + DEL")
                            ]),
                            _: 1
                          }),
                          _createTextVNode(" Deletar um item ")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_menu_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_tag, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Shift + TAB")
                            ]),
                            _: 1
                          }),
                          _createTextVNode(" Campo anterior ")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_menu_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_tag, null, {
                            default: _withCtx(() => [
                              _createTextVNode("TAB")
                            ]),
                            _: 1
                          }),
                          _createTextVNode(" Próximo campo ")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_menu_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_tag, null, {
                            default: _withCtx(() => [
                              _createTextVNode("↑")
                            ]),
                            _: 1
                          }),
                          _createTextVNode(" Campo acima ")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_menu_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_tag, null, {
                            default: _withCtx(() => [
                              _createTextVNode("↓")
                            ]),
                            _: 1
                          }),
                          _createTextVNode(" Campo abaixo ")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_a_tooltip, {
                    title: "Teclas de Atalho",
                    placement: "left"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("button", _hoisted_4, [
                        _createVNode(_component_icone, {
                          style: {"margin-top":"2px"},
                          nome: "ajuda"
                        })
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(), _createBlock(_component_a_table, {
          key: _ctx.props.chaveItens,
          loading: _ctx.props.carregando,
          columns: _ctx.state.colunasGrade.filter(item => item.visible),
          "data-source": _ctx.props.itens,
          rowKey: "codigo",
          pagination: false,
          size: "small",
          rowClassName: "ss-table-campos",
          bordered: ""
        }, {
          emptyText: _withCtx(() => [
            _createVNode(_component_mensagem_sem_dados, { mensagem: "Nenhum item adicionado ainda" })
          ]),
          bodyCell: _withCtx(({ column, record, index }) => [
            (column.key === 'acoes')
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("a", {
                    class: "visualizar",
                    title: "Editar/Visualizar",
                    onClick: ($event: any) => (_ctx.editarItem(index))
                  }, [
                    _createVNode(_component_icone, { nome: "editar" })
                  ], 8, _hoisted_9),
                  _createElementVNode("a", {
                    class: "visualizar",
                    title: "Detalhes do Produto",
                    onClick: ($event: any) => (_ctx.exibirDetalhesProduto(index))
                  }, [
                    _createVNode(_component_icone, { nome: "informacoes-fp" })
                  ], 8, _hoisted_10),
                  (_ctx.props.editavel)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        class: "excluir",
                        onClick: ($event: any) => (_ctx.excluirItem(index))
                      }, [
                        _createVNode(_component_icone, { nome: "excluir" })
                      ], 8, _hoisted_11))
                    : _createCommentVNode("", true)
                ]))
              : (column.key === 'Produto')
                ? (_openBlock(), _createBlock(_component_selecionar_produto_movimento, {
                    key: 1,
                    classCss: "hidden ss-campo-selecao-table ss-venda-itens",
                    classGroupCss: "ss-campo-selecao-table",
                    title: column.title,
                    dataAttributeColuna: column.key,
                    empresas: [_ctx.dadosEmpresa.codigoEmpresa],
                    codigoSelecionado: record.itemNotaFiscal.codigoProdutoDefinicao,
                    "onUpdate:codigoSelecionado": ($event: any) => ((record.itemNotaFiscal.codigoProdutoDefinicao) = $event),
                    descricao: record.itemNotaFiscal.descricao,
                    "onUpdate:descricao": ($event: any) => ((record.itemNotaFiscal.descricao) = $event),
                    codigoUnidadePrincipal: record.itemNotaFiscal.codigoUnidadePrincipal,
                    "onUpdate:codigoUnidadePrincipal": ($event: any) => ((record.itemNotaFiscal.codigoUnidadePrincipal) = $event),
                    fatorUnidadePrincipal: record.itemNotaFiscal.fatorUnidadePrincipal,
                    "onUpdate:fatorUnidadePrincipal": ($event: any) => ((record.itemNotaFiscal.fatorUnidadePrincipal) = $event),
                    codigoInterno: record.itemNotaFiscal.codigoProduto,
                    "onUpdate:codigoInterno": ($event: any) => ((record.itemNotaFiscal.codigoProduto) = $event),
                    codigoBarras: record.itemNotaFiscal.codigoBarras,
                    "onUpdate:codigoBarras": ($event: any) => ((record.itemNotaFiscal.codigoBarras) = $event),
                    origemMercadoria: record.itemNotaFiscal.impostos.origemMercadoria,
                    "onUpdate:origemMercadoria": ($event: any) => ((record.itemNotaFiscal.impostos.origemMercadoria) = $event),
                    codigoNcm: record.itemNotaFiscal.impostos.codigoNcm,
                    "onUpdate:codigoNcm": ($event: any) => ((record.itemNotaFiscal.impostos.codigoNcm) = $event),
                    ncm: record.itemNotaFiscal.impostos.ncm,
                    "onUpdate:ncm": ($event: any) => ((record.itemNotaFiscal.impostos.ncm) = $event),
                    emDigitacao: record.emDigitacao,
                    "onUpdate:emDigitacao": ($event: any) => ((record.emDigitacao) = $event),
                    tipoRastreabilidade: record.tipoRastreabilidade,
                    "onUpdate:tipoRastreabilidade": ($event: any) => ((record.tipoRastreabilidade) = $event),
                    tipoLancamentoRastreabilidade: record.tipoLancamentoRastreabilidade,
                    "onUpdate:tipoLancamentoRastreabilidade": ($event: any) => ((record.tipoLancamentoRastreabilidade) = $event),
                    buscarDadosAtualizados: _ctx.props.atualizarValores,
                    disabled: !_ctx.props.editavel,
                    limparSelecao: false,
                    onChange: ($event: any) => (_ctx.obterDadosFiscaisProduto(index)),
                    onValorDigitado: ($event: any) => (_ctx.salvarItemGrade(index, record)),
                    onKeydown: [
                      _withKeys(_withModifiers(($event: any) => (_ctx.exibirDetalhesProduto(index)), ["shift","exact","prevent"]), ["d"]),
                      _withKeys(_withModifiers(($event: any) => (_ctx.editarItem(index)), ["shift","exact","prevent"]), ["e"]),
                      _withKeys(_withModifiers(($event: any) => (_ctx.excluirItem(index, $event)), ["shift","exact","prevent"]), ["delete"]),
                      _cache[5] || (_cache[5] = _withKeys(_withModifiers(($event: any) => (_ctx.elementoAnterior($event)), ["prevent","shift"]), ["tab"])),
                      _withKeys(_withModifiers(($event: any) => (_ctx.verificaElementoEsquerda(record.emDigitacao, $event)), ["prevent"]), ["left"]),
                      _withKeys(_withModifiers(($event: any) => (_ctx.verificaElementoDireita(record.emDigitacao, $event)), ["prevent"]), ["right"]),
                      _withKeys(_withModifiers(($event: any) => (_ctx.verificaElementoAbaixo(record.emDigitacao, $event, column.key)), ["prevent"]), ["down"]),
                      _withKeys(_withModifiers(($event: any) => (_ctx.verificaElementoAcima(record.emDigitacao, $event, column.key)), ["prevent"]), ["up"])
                    ],
                    onKeyup: [
                      _cache[3] || (_cache[3] = _withKeys(_withModifiers(($event: any) => (_ctx.proximoElemento($event)), ["exact"]), ["tab"])),
                      _cache[4] || (_cache[4] = _withKeys(_withModifiers(($event: any) => (_ctx.proximoElemento($event)), ["exact"]), ["enter"]))
                    ]
                  }, null, 8, ["title", "dataAttributeColuna", "empresas", "codigoSelecionado", "onUpdate:codigoSelecionado", "descricao", "onUpdate:descricao", "codigoUnidadePrincipal", "onUpdate:codigoUnidadePrincipal", "fatorUnidadePrincipal", "onUpdate:fatorUnidadePrincipal", "codigoInterno", "onUpdate:codigoInterno", "codigoBarras", "onUpdate:codigoBarras", "origemMercadoria", "onUpdate:origemMercadoria", "codigoNcm", "onUpdate:codigoNcm", "ncm", "onUpdate:ncm", "emDigitacao", "onUpdate:emDigitacao", "tipoRastreabilidade", "onUpdate:tipoRastreabilidade", "tipoLancamentoRastreabilidade", "onUpdate:tipoLancamentoRastreabilidade", "buscarDadosAtualizados", "disabled", "onChange", "onValorDigitado", "onKeydown"]))
                : (column.key === 'Unidade')
                  ? (_openBlock(), _createBlock(_component_selecionar_unidade_produto_movimento, {
                      classCss: "hidden ss-campo-selecao-table ss-venda-itens",
                      classGroupCss: "ss-campo-selecao-table",
                      apenasUnidadePrincipal: false,
                      dataAttributeColuna: column.key,
                      title: record.itemNotaFiscal.descricaoUnidade,
                      codigoProdutoDefinicao: record.itemNotaFiscal.codigoProdutoDefinicao,
                      editavel: _ctx.props.editavel,
                      codigoUnidadeSelecionada: record.itemNotaFiscal.codigoUnidade,
                      "onUpdate:codigoUnidadeSelecionada": ($event: any) => ((record.itemNotaFiscal.codigoUnidade) = $event),
                      descricao: record.itemNotaFiscal.descricaoUnidade,
                      "onUpdate:descricao": ($event: any) => ((record.itemNotaFiscal.descricaoUnidade) = $event),
                      sigla: record.itemNotaFiscal.siglaUnidade,
                      "onUpdate:sigla": ($event: any) => ((record.itemNotaFiscal.siglaUnidade) = $event),
                      fracionar: record.itemNotaFiscal.fracionarUnidade,
                      "onUpdate:fracionar": ($event: any) => ((record.itemNotaFiscal.fracionarUnidade) = $event),
                      casasDecimais: record.itemNotaFiscal.casasDecimaisUnidade,
                      "onUpdate:casasDecimais": ($event: any) => ((record.itemNotaFiscal.casasDecimaisUnidade) = $event),
                      fatorConversao: record.itemNotaFiscal.fatorConversao,
                      "onUpdate:fatorConversao": ($event: any) => ((record.itemNotaFiscal.fatorConversao) = $event),
                      percentualFormacaoPreco: record.percentualFormacaoPreco,
                      "onUpdate:percentualFormacaoPreco": ($event: any) => ((record.percentualFormacaoPreco) = $event),
                      apresentarApenasSigla: true,
                      disabled: (!_ctx.props.editavel || (record.itemNotaFiscal.codigoProdutoDefinicao === 0)),
                      key: ('UNIDADE' + record.itemNotaFiscal.codigoProdutoDefinicao + _ctx.props.chaveItens + index),
                      buscarDadosAtualizados: _ctx.props.atualizarValores,
                      onChange: ($event: any) => (_ctx.alterarUnidade(index)),
                      onValorDigitado: ($event: any) => (_ctx.salvarItemGrade(index, record)),
                      onKeydown: [
                        _withKeys(_withModifiers(($event: any) => (_ctx.exibirDetalhesProduto(index)), ["shift","exact","prevent"]), ["d"]),
                        _withKeys(_withModifiers(($event: any) => (_ctx.editarItem(index)), ["shift","exact","prevent"]), ["e"]),
                        _withKeys(_withModifiers(($event: any) => (_ctx.excluirItem(index, $event)), ["shift","exact","prevent"]), ["delete"]),
                        _cache[8] || (_cache[8] = _withKeys(_withModifiers(($event: any) => (_ctx.elementoAnterior($event)), ["prevent","shift"]), ["tab"])),
                        _withKeys(_withModifiers(($event: any) => (_ctx.verificaElementoEsquerda(record.emDigitacao, $event)), ["prevent"]), ["left"]),
                        _withKeys(_withModifiers(($event: any) => (_ctx.verificaElementoDireita(record.emDigitacao, $event)), ["prevent"]), ["right"]),
                        _withKeys(_withModifiers(($event: any) => (_ctx.elementoAbaixo($event, column.key)), ["prevent"]), ["down"]),
                        _withKeys(_withModifiers(($event: any) => (_ctx.elementoAcima($event, column.key)), ["prevent"]), ["up"])
                      ],
                      onKeyup: [
                        _cache[6] || (_cache[6] = _withKeys(_withModifiers(($event: any) => (_ctx.proximoElemento($event)), ["exact"]), ["tab"])),
                        _cache[7] || (_cache[7] = _withKeys(_withModifiers(($event: any) => (_ctx.proximoElemento($event)), ["exact"]), ["enter"]))
                      ]
                    }, null, 8, ["dataAttributeColuna", "title", "codigoProdutoDefinicao", "editavel", "codigoUnidadeSelecionada", "onUpdate:codigoUnidadeSelecionada", "descricao", "onUpdate:descricao", "sigla", "onUpdate:sigla", "fracionar", "onUpdate:fracionar", "casasDecimais", "onUpdate:casasDecimais", "fatorConversao", "onUpdate:fatorConversao", "percentualFormacaoPreco", "onUpdate:percentualFormacaoPreco", "disabled", "buscarDadosAtualizados", "onChange", "onValorDigitado", "onKeydown"]))
                  : (column.key === 'Quantidade')
                    ? (_openBlock(), _createBlock(_component_campo_numerico, {
                        dataAttributeColuna0: column.key,
                        title: column.title,
                        classCss: "hidden ss-campo-numero-table ss-venda-itens",
                        classGroupCss: "hidden ss-campo-numero-table ant-input",
                        valor: record.itemNotaFiscal.quantidade,
                        "onUpdate:valor": ($event: any) => ((record.itemNotaFiscal.quantidade) = $event),
                        emDigitacao: record.emDigitacao,
                        "onUpdate:emDigitacao": ($event: any) => ((record.emDigitacao) = $event),
                        quantidadeCasasDecimais: record.itemNotaFiscal.casasDecimaisUnidade,
                        disabled: !_ctx.props.editavel,
                        key: ('QTDE' + record.itemNotaFiscal.codigoProdutoDefinicao + _ctx.props.chaveItens + index),
                        onFocus: ($event: any) => (_ctx.quantidadeFoco(index)),
                        onBlur: _ctx.quantidadeBlur,
                        onValorDigitado: ($event: any) => (_ctx.salvarItemGrade(index, record)),
                        onKeydown: [
                          _withKeys(_withModifiers(($event: any) => (_ctx.exibirDetalhesProduto(index)), ["shift","exact","prevent"]), ["d"]),
                          _withKeys(_withModifiers(($event: any) => (_ctx.editarItem(index)), ["shift","exact","prevent"]), ["e"]),
                          _withKeys(_withModifiers(($event: any) => (_ctx.excluirItem(index, $event)), ["shift","exact","prevent"]), ["delete"]),
                          _cache[11] || (_cache[11] = _withKeys(_withModifiers(($event: any) => (_ctx.elementoAnterior($event)), ["prevent","shift"]), ["tab"])),
                          _withKeys(_withModifiers(($event: any) => (_ctx.verificaElementoEsquerda(record.emDigitacao, $event)), ["prevent"]), ["left"]),
                          _withKeys(_withModifiers(($event: any) => (_ctx.verificaElementoDireita(record.emDigitacao, $event)), ["prevent"]), ["right"]),
                          _withKeys(_withModifiers(($event: any) => (_ctx.elementoAbaixo($event, column.key)), ["prevent"]), ["down"]),
                          _withKeys(_withModifiers(($event: any) => (_ctx.elementoAcima($event, column.key)), ["prevent"]), ["up"])
                        ],
                        onKeyup: [
                          _cache[9] || (_cache[9] = _withKeys(_withModifiers(($event: any) => (_ctx.proximoElemento($event)), ["exact"]), ["tab"])),
                          _cache[10] || (_cache[10] = _withKeys(_withModifiers(($event: any) => (_ctx.proximoElemento($event)), ["exact"]), ["enter"]))
                        ]
                      }, null, 8, ["dataAttributeColuna0", "title", "valor", "onUpdate:valor", "emDigitacao", "onUpdate:emDigitacao", "quantidadeCasasDecimais", "disabled", "onFocus", "onBlur", "onValorDigitado", "onKeydown"]))
                    : (column.key === 'ValorUnitario')
                      ? _withDirectives((_openBlock(), _createBlock(_component_selecionar_preco_produto_movimento, {
                          empresas: [_ctx.dadosEmpresa.codigoEmpresa],
                          "codigos-especificos": _ctx.props.tabelasPrecos,
                          codigoProdutoDefinicao: record.itemNotaFiscal.codigoProdutoDefinicao,
                          codigoItemSelecionado: record.codigoTabelaPrecoItemProduto,
                          "onUpdate:codigoItemSelecionado": ($event: any) => ((record.codigoTabelaPrecoItemProduto) = $event),
                          casasDecimais: record.itemNotaFiscal.casasDecimaisPrecoUnitario,
                          "onUpdate:casasDecimais": ($event: any) => ((record.itemNotaFiscal.casasDecimaisPrecoUnitario) = $event),
                          dadosItemTabelaPrecoSelecionado: record.dadosPrecoProduto,
                          "onUpdate:dadosItemTabelaPrecoSelecionado": ($event: any) => ((record.dadosPrecoProduto) = $event),
                          processando: _ctx.computedCarregando,
                          "onUpdate:processando": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.computedCarregando) = $event)),
                          emDigitacao: record.emDigitacao,
                          "onUpdate:emDigitacao": ($event: any) => ((record.emDigitacao) = $event),
                          disabled: !_ctx.props.editavel,
                          apresentarPrecos: (_ctx.state.apresentarPrecosItem && _ctx.state.indexDetalhesPreco === index),
                          popOverHover: _ctx.state.popOverHoverPrecosItem,
                          "onUpdate:popOverHover": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.state.popOverHoverPrecosItem) = $event)),
                          inputFocus: _ctx.state.inputFocusPrecosItem,
                          "onUpdate:inputFocus": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.state.inputFocusPrecosItem) = $event)),
                          identificacaoElemento: ('VUNIT' + record.itemNotaFiscal.codigoProdutoDefinicao + _ctx.props.chaveItens + index),
                          key: ('SEL-PRECO' + record.itemNotaFiscal.codigoProdutoDefinicao + _ctx.props.chaveItens + index),
                          onDefinirPrecoSelecionado: ($event: any) => (_ctx.defineValorUnitarioCalculaTotal(index, $event)),
                          onValorDigitado: ($event: any) => (_ctx.salvarItemGrade(index, record)),
                          onBlur: _ctx.precoBlur
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(), _createBlock(_component_campo_numerico, {
                              dataAttributeColuna: column.key,
                              title: column.title,
                              monetario: true,
                              classGroupCss: "hidden ss-campo-numero-table",
                              classCss: "hidden ss-campo-numero-table ss-venda-itens",
                              valor: record.itemNotaFiscal.precoUnitario,
                              "onUpdate:valor": ($event: any) => ((record.itemNotaFiscal.precoUnitario) = $event),
                              emDigitacao: record.emDigitacao,
                              "onUpdate:emDigitacao": ($event: any) => ((record.emDigitacao) = $event),
                              disabled: !_ctx.props.editavel,
                              quantidadeCasasDecimais: record.itemNotaFiscal.casasDecimaisPrecoUnitario,
                              key: ('VUNIT' + record.itemNotaFiscal.codigoProdutoDefinicao + _ctx.props.chaveItens + index),
                              onFocus: ($event: any) => (_ctx.precoFoco(index)),
                              onBlur: _ctx.precoBlur,
                              onValorDigitado: ($event: any) => (_ctx.salvarItemGrade(index, record)),
                              onKeydown: [
                                _withKeys(_withModifiers(($event: any) => (_ctx.exibirDetalhesProduto(index)), ["shift","exact","prevent"]), ["d"]),
                                _withKeys(_withModifiers(($event: any) => (_ctx.editarItem(index)), ["shift","exact","prevent"]), ["e"]),
                                _withKeys(_withModifiers(($event: any) => (_ctx.excluirItem(index, $event)), ["shift","exact","prevent"]), ["delete"]),
                                _cache[14] || (_cache[14] = _withKeys(_withModifiers(($event: any) => (_ctx.elementoAnterior($event)), ["prevent","shift"]), ["tab"])),
                                _withKeys(_withModifiers(($event: any) => (_ctx.verificaElementoEsquerda(record.emDigitacao, $event)), ["prevent"]), ["left"]),
                                _withKeys(_withModifiers(($event: any) => (_ctx.verificaElementoDireita(record.emDigitacao, $event)), ["prevent"]), ["right"]),
                                _withKeys(_withModifiers(($event: any) => (_ctx.elementoAbaixo($event, column.key)), ["prevent"]), ["down"]),
                                _withKeys(_withModifiers(($event: any) => (_ctx.elementoAcima($event, column.key)), ["prevent"]), ["up"])
                              ],
                              onKeyup: [
                                _cache[12] || (_cache[12] = _withKeys(_withModifiers(($event: any) => (_ctx.proximoElemento($event)), ["exact"]), ["tab"])),
                                _cache[13] || (_cache[13] = _withKeys(_withModifiers(($event: any) => (_ctx.proximoElemento($event)), ["exact"]), ["enter"]))
                              ]
                            }, null, 8, ["dataAttributeColuna", "title", "valor", "onUpdate:valor", "emDigitacao", "onUpdate:emDigitacao", "disabled", "quantidadeCasasDecimais", "onFocus", "onBlur", "onValorDigitado", "onKeydown"]))
                          ]),
                          _: 2
                        }, 1032, ["empresas", "codigos-especificos", "codigoProdutoDefinicao", "codigoItemSelecionado", "onUpdate:codigoItemSelecionado", "casasDecimais", "onUpdate:casasDecimais", "dadosItemTabelaPrecoSelecionado", "onUpdate:dadosItemTabelaPrecoSelecionado", "processando", "emDigitacao", "onUpdate:emDigitacao", "disabled", "apresentarPrecos", "popOverHover", "inputFocus", "identificacaoElemento", "onDefinirPrecoSelecionado", "onValorDigitado", "onBlur"])), [
                          [_vShow, (record.itemNotaFiscal.codigoProdutoDefinicao > 0)]
                        ])
                      : (column.key === 'Icms')
                        ? (_openBlock(), _createBlock(_component_campo_numerico, {
                            key: 5,
                            classCss: "hidden ss-campo-numero-table ss-venda-itens",
                            classGroupCss: "hidden ss-campo-numero-table",
                            title: column.title,
                            dataAttributeColuna: column.key,
                            valor: record.itemNotaFiscal.impostos.icms.aliquotaIcms,
                            "onUpdate:valor": ($event: any) => ((record.itemNotaFiscal.impostos.icms.aliquotaIcms) = $event),
                            percentual: true,
                            disabled: !_ctx.props.editavel,
                            emDigitacao: record.emDigitacao,
                            "onUpdate:emDigitacao": ($event: any) => ((record.emDigitacao) = $event),
                            onValorDigitado: ($event: any) => (_ctx.salvarItemGrade(index, record)),
                            onKeydown: [
                              _withKeys(_withModifiers(($event: any) => (_ctx.exibirDetalhesProduto(index)), ["shift","exact","prevent"]), ["d"]),
                              _withKeys(_withModifiers(($event: any) => (_ctx.editarItem(index)), ["shift","exact","prevent"]), ["e"]),
                              _withKeys(_withModifiers(($event: any) => (_ctx.excluirItem(index, $event)), ["shift","exact","prevent"]), ["delete"]),
                              _cache[20] || (_cache[20] = _withKeys(_withModifiers(($event: any) => (_ctx.elementoAnterior($event)), ["prevent","shift"]), ["tab"])),
                              _withKeys(_withModifiers(($event: any) => (_ctx.verificaElementoEsquerda(record.emDigitacao, $event)), ["prevent"]), ["left"]),
                              _withKeys(_withModifiers(($event: any) => (_ctx.verificaElementoDireita(record.emDigitacao, $event)), ["prevent"]), ["right"]),
                              _withKeys(_withModifiers(($event: any) => (_ctx.elementoAbaixo($event, column.key)), ["prevent"]), ["down"]),
                              _withKeys(_withModifiers(($event: any) => (_ctx.elementoAcima($event, column.key)), ["prevent"]), ["up"])
                            ],
                            onKeyup: [
                              _cache[18] || (_cache[18] = _withKeys(_withModifiers(($event: any) => (_ctx.proximoElemento($event)), ["exact"]), ["tab"])),
                              _cache[19] || (_cache[19] = _withKeys(_withModifiers(($event: any) => (_ctx.proximoElemento($event)), ["exact"]), ["enter"]))
                            ]
                          }, null, 8, ["title", "dataAttributeColuna", "valor", "onUpdate:valor", "disabled", "emDigitacao", "onUpdate:emDigitacao", "onValorDigitado", "onKeydown"]))
                        : (column.key === 'Ipi')
                          ? (_openBlock(), _createBlock(_component_campo_numerico, {
                              key: 6,
                              classCss: "hidden ss-campo-numero-table ss-venda-itens",
                              classGroupCss: "hidden ss-campo-numero-table",
                              title: column.title,
                              dataAttributeColuna: column.key,
                              valor: record.itemNotaFiscal.impostos.ipi.aliquotaIpi,
                              "onUpdate:valor": ($event: any) => ((record.itemNotaFiscal.impostos.ipi.aliquotaIpi) = $event),
                              percentual: true,
                              disabled: !_ctx.props.editavel,
                              emDigitacao: record.emDigitacao,
                              "onUpdate:emDigitacao": ($event: any) => ((record.emDigitacao) = $event),
                              onValorDigitado: ($event: any) => (_ctx.salvarItemGrade(index, record)),
                              onKeydown: [
                                _withKeys(_withModifiers(($event: any) => (_ctx.exibirDetalhesProduto(index)), ["shift","exact","prevent"]), ["d"]),
                                _withKeys(_withModifiers(($event: any) => (_ctx.editarItem(index)), ["shift","exact","prevent"]), ["e"]),
                                _withKeys(_withModifiers(($event: any) => (_ctx.excluirItem(index, $event)), ["shift","exact","prevent"]), ["delete"]),
                                _cache[23] || (_cache[23] = _withKeys(_withModifiers(($event: any) => (_ctx.elementoAnterior($event)), ["prevent","shift"]), ["tab"])),
                                _withKeys(_withModifiers(($event: any) => (_ctx.verificaElementoEsquerda(record.emDigitacao, $event)), ["prevent"]), ["left"]),
                                _withKeys(_withModifiers(($event: any) => (_ctx.verificaElementoDireita(record.emDigitacao, $event)), ["prevent"]), ["right"]),
                                _withKeys(_withModifiers(($event: any) => (_ctx.elementoAbaixo($event, column.key)), ["prevent"]), ["down"]),
                                _withKeys(_withModifiers(($event: any) => (_ctx.elementoAcima($event, column.key)), ["prevent"]), ["up"])
                              ],
                              onKeyup: [
                                _cache[21] || (_cache[21] = _withKeys(_withModifiers(($event: any) => (_ctx.proximoElemento($event)), ["exact"]), ["tab"])),
                                _cache[22] || (_cache[22] = _withKeys(_withModifiers(($event: any) => (_ctx.proximoElemento($event)), ["exact"]), ["enter"]))
                              ]
                            }, null, 8, ["title", "dataAttributeColuna", "valor", "onUpdate:valor", "disabled", "emDigitacao", "onUpdate:emDigitacao", "onValorDigitado", "onKeydown"]))
                          : (column.key === 'Desconto')
                            ? (_openBlock(), _createBlock(_component_campo_numerico, {
                                key: 7,
                                title: column.title,
                                dataAttributeColuna: column.key,
                                valor: record.itemNotaFiscal.valorDesconto,
                                "onUpdate:valor": ($event: any) => ((record.itemNotaFiscal.valorDesconto) = $event),
                                emDigitacao: record.emDigitacao,
                                "onUpdate:emDigitacao": ($event: any) => ((record.emDigitacao) = $event),
                                monetario: true,
                                valorMaximo: 0,
                                classGroupCss: "hidden ss-campo-numero-table",
                                classCss: "hidden ss-campo-numero-table ss-venda-itens",
                                disabled: !_ctx.props.editavel,
                                onValorDigitado: ($event: any) => (_ctx.salvarItemGrade(index, record)),
                                onKeydown: [
                                  _withKeys(_withModifiers(($event: any) => (_ctx.exibirDetalhesProduto(index)), ["shift","exact","prevent"]), ["d"]),
                                  _withKeys(_withModifiers(($event: any) => (_ctx.editarItem(index)), ["shift","exact","prevent"]), ["e"]),
                                  _withKeys(_withModifiers(($event: any) => (_ctx.excluirItem(index, $event)), ["shift","exact","prevent"]), ["delete"]),
                                  _cache[24] || (_cache[24] = _withKeys(_withModifiers(($event: any) => (_ctx.elementoAnterior($event)), ["prevent","shift"]), ["tab"])),
                                  _withKeys(_withModifiers(($event: any) => (_ctx.verificaElementoEsquerda(record.emDigitacao, $event)), ["prevent"]), ["left"]),
                                  _withKeys(_withModifiers(($event: any) => (_ctx.verificaElementoDireita(record.emDigitacao, $event)), ["prevent"]), ["right"]),
                                  _withKeys(_withModifiers(($event: any) => (_ctx.elementoAbaixo($event, column.key)), ["prevent"]), ["down"]),
                                  _withKeys(_withModifiers(($event: any) => (_ctx.elementoAcima($event, column.key)), ["prevent"]), ["up"])
                                ],
                                onKeyup: [
                                  _withKeys(_withModifiers(($event: any) => (_ctx.verificaElementoProximoElementoDesconto(record.emDigitacao, index, $event)), ["exact"]), ["tab"]),
                                  _withKeys(_withModifiers(($event: any) => (_ctx.verificaElementoProximoElementoDesconto(record.emDigitacao, index, $event)), ["exact"]), ["enter"])
                                ]
                              }, null, 8, ["title", "dataAttributeColuna", "valor", "onUpdate:valor", "emDigitacao", "onUpdate:emDigitacao", "disabled", "onValorDigitado", "onKeydown", "onKeyup"]))
                            : (column.key === 'Total')
                              ? (_openBlock(), _createBlock(_component_campo_numerico, {
                                  key: 8,
                                  title: column.title,
                                  dataAttributeColuna: column.key,
                                  valor: record.itemNotaFiscal.valorTotal,
                                  monetario: true,
                                  disabled: true,
                                  classGroupCss: "hidden ss-campo-numero-table",
                                  classCss: "hidden ss-campo-numero-table"
                                }, null, 8, ["title", "dataAttributeColuna", "valor"]))
                              : (column.key === 'Item')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                    _createElementVNode("span", null, [
                                      _createElementVNode("a", {
                                        onClick: ($event: any) => (_ctx.editarItem(index))
                                      }, [
                                        _createElementVNode("span", null, _toDisplayString(record.itemNotaFiscal.descricao), 1)
                                      ], 8, _hoisted_13)
                                    ]),
                                    _createElementVNode("span", null, "Quantidade: " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.itemNotaFiscal.quantidade,
                    record.itemNotaFiscal.casasDecimaisUnidade)) + "(" + _toDisplayString(record.itemNotaFiscal.siglaUnidade) + ") ", 1),
                                    _createElementVNode("span", null, "Vlr Unitário: " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.itemNotaFiscal.precoUnitario,
                    record.itemNotaFiscal.casasDecimaisPrecoUnitario, true)), 1),
                                    _createElementVNode("span", null, "Desconto: " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.itemNotaFiscal.valorDesconto, 2, true)), 1),
                                    _createElementVNode("span", null, "Total: " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.itemNotaFiscal.valorTotal, 2, true)), 1),
                                    _createElementVNode("div", _hoisted_14, [
                                      _createElementVNode("a", {
                                        class: "visualizar",
                                        onClick: ($event: any) => (_ctx.editarItem(index))
                                      }, [
                                        _createVNode(_component_icone, { nome: "editar" })
                                      ], 8, _hoisted_15),
                                      (_ctx.props.editavel)
                                        ? (_openBlock(), _createElementBlock("a", {
                                            key: 0,
                                            class: "excluir",
                                            onClick: ($event: any) => (_ctx.excluirItem(index))
                                          }, [
                                            _createVNode(_component_icone, { nome: "excluir" })
                                          ], 8, _hoisted_16))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["loading", "columns", "data-source"]))
      ])
    ]),
    _createVNode(_component_venda_item_modal, {
      visivel: _ctx.state.exibirDetalhesItem,
      "onUpdate:visivel": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.state.exibirDetalhesItem) = $event)),
      empresa: _ctx.dadosEmpresa.codigoEmpresa,
      pessoa: 0,
      dadosPessoaMovimento: _ctx.props.dadosPessoaMovimento,
      tabelasPrecos: _ctx.props.tabelasPrecos,
      totalNota: _ctx.props.totalVenda,
      item: _ctx.state.itemSelecionado,
      existeAnterior: _ctx.state.existeAnterior,
      existeProximo: _ctx.state.existeProximo,
      editavel: _ctx.props.editavel,
      incidencias: _ctx.props.incidencias,
      estoquesDisponiveis: [],
      atualizarValores: _ctx.props.atualizarValores,
      onSalvar: _ctx.salvarItem,
      onProximoItem: _ctx.proximoItem,
      onItemAnterior: _ctx.itemAnterior
    }, null, 8, ["visivel", "empresa", "dadosPessoaMovimento", "tabelasPrecos", "totalNota", "item", "existeAnterior", "existeProximo", "editavel", "incidencias", "atualizarValores", "onSalvar", "onProximoItem", "onItemAnterior"]),
    _createVNode(_component_detalhes_produto_modal, {
      visivel: _ctx.state.exibirDetalhesProduto,
      "onUpdate:visivel": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.state.exibirDetalhesProduto) = $event)),
      empresa: _ctx.dadosEmpresa.codigoEmpresa,
      definicaoProduto: _ctx.state.codigoDefinicaoSelecionada
    }, null, 8, ["visivel", "empresa", "definicaoProduto"]),
    _createVNode(_component_selecionar_kit_produtos_modal, {
      visivel: _ctx.state.exibirSelecionarKitProduto,
      "onUpdate:visivel": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.state.exibirSelecionarKitProduto) = $event)),
      empresa: _ctx.dadosEmpresa.codigoEmpresa,
      onConfirmacao: _ctx.utilizarKit
    }, null, 8, ["visivel", "empresa", "onConfirmacao"]),
    _createVNode(_component_consulta_produtos_modal, {
      visivel: _ctx.state.exibirConsultaProdutos,
      "onUpdate:visivel": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.state.exibirConsultaProdutos) = $event)),
      "tipo-selecao": 1,
      empresa: _ctx.dadosEmpresa.codigoEmpresa
    }, null, 8, ["visivel", "empresa"])
  ]))
}